import { render, staticRenderFns } from "./FrameModal.vue?vue&type=template&id=1c0c5cc2"
import script from "./FrameModal.vue?vue&type=script&lang=js"
export * from "./FrameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports